module.exports = __webpack_public_path__ + "img/smoke.1d2f9d37.png";